import React from 'react';
import BasicHeader from '@fingo/lib/components/headers/BasicHeader';
import CircularProgress from '@mui/material/CircularProgress';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import CredentialsCard from '../components/credentials/CredentialsCard';
import useCompanyCredentials from '../hooks/useCompanyCredentials';

const Credentials = () => {
  const companyCredentials = useCompanyCredentials();
  if (!companyCredentials.length) return <CircularProgress />;

  return (
    <Stack spacing={1} py={5} px={4} flexGrow={1} bgcolor="#FFFFFF">
      <BasicHeader title="Mis credenciales" />
      <Typography mt="16px !important">
        Porque te queremos entregar la experiencia Fingo completa,{' '}
        <strong>ingresa tus credenciales</strong> y acelerarás tus procesos en nuestra plataforma.
      </Typography>
      <Typography mb="16px !important" mt="4px !important">
        Recuerda que las <strong>claves en Fingo están encriptadas</strong>, por lo que están
        seguras con nosotros.
      </Typography>
      <Grid container spacing={2}>
        {companyCredentials.map((document) => (
          <Grid key={document.title} item xs={12} md={6}>
            <CredentialsCard {...document} />
          </Grid>
        ))}
      </Grid>
    </Stack>
  );
};

export default Credentials;
